module.exports = __webpack_public_path__ + "img/simon_zsuzsi_c80_A3-01.7034e3ec.jpg";